<template>
  <div>
    <el-card class="box-card">
      <el-button type="info" @click="clickback">返回</el-button>
      <el-table :data="listlog" border stripe class="mt15">
        <el-table-column prop="Name" label="姓名" min-width="10%"></el-table-column>
        <el-table-column prop="Age" label="年龄" min-width="10%"></el-table-column>
        <el-table-column prop="operation" label="操作" min-width="10%">
          <template v-slot="scope">
            <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickqrcode(scope.row)">二维码</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 弹出框 -->
    <el-dialog title="" :visible.sync="dialogQrcode" width="240px" @close="closeCode" :close-on-click-modal="false">
      <div class="qrcode" ref="qrCodeUrl"></div>
    </el-dialog>
    <!-- 弹出框 end -->
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
import QRCode from 'qrcodejs2'
Vue.use(VueAxios, axios)

export default {
  components: {
  },
  data () {
    return {
      listlog: [],
      dialogQrcode: false,
      Openid: null
    }
  },
  methods: {
    LoadData (parentdata) {
      this.Openid = parentdata.params.Openid
      this.apiGetMiniappShaichaWxuserListSub()
    },
    clickback () {
      this.$emit('triggerFunc', '')
    },
    clickqrcode (row) {
      var that = this
      that.dialogQrcode = true
      that.$nextTick(() => {
        var qrcode = new QRCode(that.$refs.qrCodeUrl, {
          text: row.Qrcode, // 需要转换为二维码的内容
          width: 200,
          height: 200,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H
        })
      })
    },
    // 关闭弹框,清除已经生成的二维码
    closeCode () {
      this.$refs.qrCodeUrl.innerHTML = ''
    },
    apiGetMiniappShaichaWxuserListSub: function (type, parentid) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        openid: this.Openid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetMiniappShaichaWxuserListSub, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.listlog = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.select1 {
    width: 109px;
    margin-right: 15px;
}
.speed {
    width: 440px;
    margin-right: 15px;
}
.qrcode{
    display: inline-block;
    align: 'center';
    img {
        width: 132px;
        height: 132px;
        background-color: #fff; //设置白色背景色
        padding: 6px; // 利用padding的特性，挤出白边
        box-sizing: border-box;
    }
}
</style>
